import { render, staticRenderFns } from "./settingCompany.vue?vue&type=template&id=d1b98b04&scoped=true&"
import script from "./settingCompany.vue?vue&type=script&lang=js&"
export * from "./settingCompany.vue?vue&type=script&lang=js&"
import style0 from "./settingCompany.vue?vue&type=style&index=0&id=d1b98b04&prod&lang=scss&scoped=true&"
import style1 from "./settingCompany.vue?vue&type=style&index=1&id=d1b98b04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b98b04",
  null
  
)

export default component.exports